/** mm:ss for the live session timer; "--:--" before the clock anchors. */
export function formatElapsed(seconds: number | null): string {
  if (seconds === null) {
    return "--:--"
  }
  const minutes = Math.floor(seconds / 60)
  const remainder = Math.floor(seconds % 60)
  return `${String(minutes).padStart(2, "0")}:${String(remainder).padStart(2, "0")}`
}
